import { Theme } from '@mui/material/styles';
import { InputSelectIcon } from './CustomIcons';

export default function Autocomplete(theme: Theme) {
  return {
    MuiAutocomplete: {
      defaultProps: {
        // MUI Autocomplete already wraps `popupIcon` in a popupIndicator <button>. Wrapping the
        // icon in its own <IconButton> here causes a <button>-inside-<button> hydration error
        // (React logs it loudly in strict mode). Pass just the bare SvgIcon: the wrapper button
        // is provided by MUI, our slotProps below still disable its ripple.
        popupIcon: <InputSelectIcon />,
        slotProps: {
          popupIndicator: {
            disableRipple: true,
          },
        },
      },

      styleOverrides: {
        popupIndicator: {
          transform: 'none', // Remove default transform, the icon does it
          '&.MuiAutocomplete-popupIndicatorOpen': {
            transform: 'none', // Remove default transform when open, the icon does it
          },
        },
        // The popup renders in a Popper (not a Popover/Menu), so it misses the global
        // MuiPopover dropdown shadow and — with MuiPaper defaulting to elevation 0 — would
        // render flat. Give it the same dropdown shadow as every other overlay dropdown.
        paper: {
          boxShadow: theme.customShadows.dropdown,
        },
      },
    },
  };
}
